import { useDataChange, useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let city = useDataValue({
    context: 'contact_method_association',
    path: 'postal_address.city',
    viewPath: props.viewPath,
  })
  let setCity = useDataChange({
    context: 'contact_method_association',
    path: 'postal_address.city',
    viewPath: props.viewPath,
  })

  return async function onChange(value) {
    if (value.term !== city) {
      setCity(value.term)
    }
  }
}
